import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { __decorate, __extends } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import MixinsCom from './mixins';

var DetailModal = function (_super) {
  __extends(DetailModal, _super);

  function DetailModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.modalVisible = false;
    _this.detailData = {};
    return _this;
  }

  DetailModal.prototype.getFilename = function (path) {
    if (!path) {
      return path;
    }

    return path.split('/')[path.split('/').length - 1];
  };

  DetailModal = __decorate([Component], DetailModal);
  return DetailModal;
}(Mixins(MixinsCom));

export default DetailModal;